module.exports = __webpack_public_path__ + "static/media/Aldine-721-BT.54ae6341.ttf";